import * as React from 'react';
import ComponentBasic from 'kts-scaffold-framework/component/ComponentBasic';
import { ModulesBasic, IPropsBasic, ModulesRoot } from 'kts-scaffold-framework/modules';
import { connect } from 'kts-platform-frame/redux';
import ReduxState, { } from 'kts-platform-frame/redux/ReduxState';
import AppContainerState from './AppContainerState';
import IAppContainerProps from './IAppContainerProps';

/** App容器 */
export default class AppContainer extends ComponentBasic<IAppContainerProps, AppContainerState> {

    public readonly state: AppContainerState = new AppContainerState();

    constructor(props: IAppContainerProps) {
        super(props);
    }

    componentDidMount() {
        this.initialization();
    }

    render() {
        const App = this.state.App;
        if (App) {
            return <App {...this.props} />;
        } else {
            return <div>JS加载中...</div>;
        }
    }

    /** js的地址列表 */
    private get jsUrlList(): string[] {
        if(typeof this.props.jsUrl === 'string'){
            return [this.props.jsUrl];
        }
        return this.props.jsUrl;
    }

    /** css地址列表 */
    private get cssUrlList(): string[] {
        if(typeof this.props.cssUrl === 'string'){
            return [this.props.cssUrl];
        }
        return this.props.cssUrl;
    }

    private initialization = async () => {
        console.log('');
        // 'http://localhost:3300/app.js'
    }
}


// WEBPACK FOOTER //
// ./src/node_modules/kts-platform-frame/display/components/AppContainer/index.tsx